/**
 * User profile favorites keys
 */
export const GAILGPT_FAVORITES_KEY = "gailgpt_favorite_gail_ids";

// Stored as a single-element string[] to fit the existing favorites shape
// (Record<string, string[]>). Empty array = no personal default; fall back to org default.
export const GAILGPT_USER_DEFAULT_ASSISTANT_KEY = "gailgpt_user_default_assistant_id";

